// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  width: 100%;
  height: 86px;
  background-color: rgb(206, 196, 196);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  align-items: center;
  z-index: 100;
  position: fixed;
  top: 0;
  padding-right: 35%;
}
.links-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}
nav a {
  height: 100%;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: black;
  font-size: 25px;
  font-weight: bold;
}
nav button {
  height: 100%;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  color: black;
  font-size: 30px;
  font-weight: bold;
}
#picture {
  display: none;
}
nav a img {
  height: 75px;
}
nav a:hover {
  background-color: rgb(169, 169, 169);
  box-shadow: 8px 4px 8px 5px rgba(0, 0, 0, 0.6);
}
nav button:hover {
  background-color: rgb(169, 169, 169);
  box-shadow: 8px 4px 8px 5px rgba(0, 0, 0, 0.6);
}
nav .home-link {
  display: flex;
  justify-content: flex-start;
  margin-right: auto;
}
nav .login-link img {
  background: rgba(95, 14, 14, 0.555);
}
nav .home-link-1 {
  display: none;
}
nav .login-link-1 img {
  background: rgba(95, 14, 14, 0.555);
}
nav .login-link {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}
nav svg {
  fill: black;
}
#sidebar-active {
  display: none;
}
.open-sidebar-button, .close-sidebar-button {
  display: none;
}
@media(max-width: 1200px) {
  nav a {
    padding: 0 5px;
    font-size: 20px;
  } 
  nav button {
    padding: 0 5px;
    font-size: 22px;
  }
}
@media(max-width: 900px){
  .header img {
    display: none;
  }
  .sticky + .page {
    padding-top: 120px;
  } 
  .links-container {
    flex-direction: column;
    align-items: flex-start;
    position: fixed;
    top: 0;
    right: -100%;
    z-index: 102;
    width: 250px;
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    box-shadow: -10px 0 10px rgba(0, 0, 0, 0.1);
    transition: 0.75s ease-out;
  }
  nav .home-link {
    display: none;
  }
  nav .home-link-1 {
    display: flex;
    justify-content: flex-start;
    margin-right: auto;
  }
  nav .login-link {
    box-sizing: border-box;
    height: auto;
    width: 100%;
    padding: 20px 30px;
    justify-content: flex-start;
  }
  nav a {
    box-sizing: border-box;
    height: auto;
    width: 100%;
    padding: 20px 30px;
    justify-content: flex-start;
  }
  .open-sidebar-button, .close-sidebar-button {
    padding: 20px;
    display: block;
    position: absolute;
    right: 20px
  }
  #sidebar-active:checked ~ .links-container {
    right: 0;
  }
  #sidebar-active:checked ~ #overlay {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/nav-bar-2.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,4EAA4E;EAC5E,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,MAAM;EACN,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;AACA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;AACf;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,0CAA0C;IAC1C,2BAA2B;IAC3B,2CAA2C;IAC3C,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB;EACF;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;EACd;AACF","sourcesContent":["nav {\n  width: 100%;\n  height: 86px;\n  background-color: rgb(206, 196, 196);\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  display: flex;\n  align-items: center;\n  z-index: 100;\n  position: fixed;\n  top: 0;\n  padding-right: 35%;\n}\n.links-container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n}\nnav a {\n  height: 100%;\n  padding: 0 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  color: black;\n  font-size: 25px;\n  font-weight: bold;\n}\nnav button {\n  height: 100%;\n  padding: 0 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: none;\n  border: none;\n  color: black;\n  font-size: 30px;\n  font-weight: bold;\n}\n#picture {\n  display: none;\n}\nnav a img {\n  height: 75px;\n}\nnav a:hover {\n  background-color: rgb(169, 169, 169);\n  box-shadow: 8px 4px 8px 5px rgba(0, 0, 0, 0.6);\n}\nnav button:hover {\n  background-color: rgb(169, 169, 169);\n  box-shadow: 8px 4px 8px 5px rgba(0, 0, 0, 0.6);\n}\nnav .home-link {\n  display: flex;\n  justify-content: flex-start;\n  margin-right: auto;\n}\nnav .login-link img {\n  background: rgba(95, 14, 14, 0.555);\n}\nnav .home-link-1 {\n  display: none;\n}\nnav .login-link-1 img {\n  background: rgba(95, 14, 14, 0.555);\n}\nnav .login-link {\n  display: flex;\n  justify-content: flex-end;\n  margin-left: auto;\n}\nnav svg {\n  fill: black;\n}\n#sidebar-active {\n  display: none;\n}\n.open-sidebar-button, .close-sidebar-button {\n  display: none;\n}\n@media(max-width: 1200px) {\n  nav a {\n    padding: 0 5px;\n    font-size: 20px;\n  } \n  nav button {\n    padding: 0 5px;\n    font-size: 22px;\n  }\n}\n@media(max-width: 900px){\n  .header img {\n    display: none;\n  }\n  .sticky + .page {\n    padding-top: 120px;\n  } \n  .links-container {\n    flex-direction: column;\n    align-items: flex-start;\n    position: fixed;\n    top: 0;\n    right: -100%;\n    z-index: 102;\n    width: 250px;\n    background-color: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n    box-shadow: -10px 0 10px rgba(0, 0, 0, 0.1);\n    transition: 0.75s ease-out;\n  }\n  nav .home-link {\n    display: none;\n  }\n  nav .home-link-1 {\n    display: flex;\n    justify-content: flex-start;\n    margin-right: auto;\n  }\n  nav .login-link {\n    box-sizing: border-box;\n    height: auto;\n    width: 100%;\n    padding: 20px 30px;\n    justify-content: flex-start;\n  }\n  nav a {\n    box-sizing: border-box;\n    height: auto;\n    width: 100%;\n    padding: 20px 30px;\n    justify-content: flex-start;\n  }\n  .open-sidebar-button, .close-sidebar-button {\n    padding: 20px;\n    display: block;\n    position: absolute;\n    right: 20px\n  }\n  #sidebar-active:checked ~ .links-container {\n    right: 0;\n  }\n  #sidebar-active:checked ~ #overlay {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 101;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
